export default __webpack_public_path__ + "static/media/spd-bbc-img.b8801b93.webp";